import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";


function Dropzone(props) {
  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    noDrag: true,
    onDrop: (acceptedFiles) => {
      setFiles(acceptedFiles);
      if (props.onChange) {
        props.onChange(acceptedFiles);
      }
    }
  });

  const removeFile = file => () => {
    const newFiles = [...files];
    newFiles.splice(newFiles.indexOf(file), 1);
    setFiles(newFiles);
  };

  const files_name = files.map(file => (
    <div key={file.name}>
      <p>{file.name}
        <button
          onClick={removeFile(file)}
          className="btn btn-warning btn-sm ml-3"
        >
          Remover arquivo
        </button>
      </p>
    </div>
  ));

  return (
    <div className="d-block mt-4">
      {files.length === 0 && (
        <div
          {...getRootProps({ className: "btn-dropzone border p-1 mb-2" })}
          style={{ cursor: 'pointer' }}
        >
          <input {...getInputProps()} />
          <span>Adicionar arquivo</span>
        </div>
      )}
      <aside>{files_name}</aside>
    </div>
  );
}

export default Dropzone;



// WEBPACK FOOTER //
// ./src/components/Pages/Unicef/Dropzone.js